import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavController } from '@ionic/angular';
import { DefaultPageComponent } from '../../shared/page/default-page.component';
import { AnalycticsNativeService } from '../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { BackNativeService } from '../../shared/service/comunicator-native/back-native/back-native';
import { ReturnNativeService } from '../../shared/service/comunicator-native/return-native/return-native';
import { AnalyticsPageModel } from '../../shared/model/analyticsPage';
import { AnalyticsPageService } from '../../shared/service/analytics/analytics-page.service';
import { JourneyService } from '../../shared/service/journey/journey.service';
import { TrackTypes } from '../../shared/service/journey/tracks/model/track-types';
import { AnalyticsGA4PagesModel } from '../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';
import { AnalyticsGA4PageService } from '../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { DeviceInfoNativeService } from '../../shared/service/comunicator-native/device-info-native/device-info-native';


@Component({
  selector: 'app-broker-registration',
  templateUrl: './broker-registration.component.html',
  styleUrls: ['./broker-registration.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BrokerRegistrationComponent extends DefaultPageComponent implements OnInit  {

  headerId = 'broker-registration';
  focusId: string;
  approved = false;
  titleContent: string;
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public returnNativeService: ReturnNativeService,
    private analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private deviceInfoNativeService: DeviceInfoNativeService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
   }

  ngOnInit() {
    this.headerFocus();
  }

  ionViewWillEnter() {
    this.focusPageWithDetail(this.focusId);
  }

  getPageId(): string {
    return this.headerId;
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  clickNext(){
    this.router.navigateForward(`/?journey=${TrackTypes.BASIC_V2}`);
    this.deviceInfoNativeService.getItemCommunicator();
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.brokerRegistration;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = {
      it_eventaction: this.analyticsPage.actionClose,
      it_eventlabel: this.analyticsPage.close,
      it_pagename: this.analyticsPage.brokerRegistration
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathAtualizacao,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }


}
